import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["Icon", "text", "href", "target", "title", "isBeta", "showIcon"],
    _excluded2 = ["type", "href", "icon", "title", "onClick"],
    _excluded3 = ["as", "title", "href", "items", "blank", "isBeta"],
    _excluded4 = ["as"];
import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { arrayOf, bool, elementType, func, node, number, oneOf, oneOfType, shape, string } from 'prop-types';
import { useMediaQuery } from "../../../hooks";
import { ArrowLeft, BetaLabel, ChevronNormalRight, CloseLinear, Growth, S7, S7Circle, S7Profi, S7ProfiCircle, S7Shop } from "../../../icons";
import { TextBase } from "../../../internal/TextBase";
import { isNumber, isObject, isString } from "../../../utils/type";
import Link from '../../../Link';
import Scrollbar from '../../../Scrollbar';
import Search from '../../../Search';
import Title from '../../../Title';
import { pointTypes, pointTypesEnum, themes } from '../../constants';
import { HeaderSearch } from '../HeaderSearch';
import styles from './MobileMenu.css';
var cx = classNames.bind(styles);

var renderLink = function renderLink( // исключаем Icon, text, которые используются в Menu (desktop)
_ref, onClick) {
  var Icon = _ref.Icon,
      text = _ref.text,
      href = _ref.href,
      target = _ref.target,
      title = _ref.title,
      isBeta = _ref.isBeta,
      showIcon = _ref.showIcon,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({
    className: cx('link'),
    href: href,
    onClick: onClick,
    target: target
  }, rest), /*#__PURE__*/React.createElement(TextBase, {
    as: "span"
  }, title, isBeta && /*#__PURE__*/React.createElement("span", {
    className: cx('beta')
  }, /*#__PURE__*/React.createElement(BetaLabel, null)), showIcon && /*#__PURE__*/React.createElement("span", {
    className: cx('new_window')
  }, /*#__PURE__*/React.createElement(Growth, {
    width: 12
  }))));
};

var renderSubMenuItem = function renderSubMenuItem(item, onClose) {
  var type = item.type,
      href = item.href,
      icon = item.icon,
      title = item.title,
      onClick = item.onClick,
      rest = _objectWithoutProperties(item, _excluded2);

  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }

    onClose();
  };

  switch (type) {
    case pointTypesEnum.button:
      return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
        className: cx('item_button'),
        href: href,
        onClick: handleClick
      }), icon && /*#__PURE__*/React.createElement("span", {
        className: cx('item_button_icon')
      }, /*#__PURE__*/React.createElement(item.icon, null)), title);

    case pointTypesEnum.text:
      return /*#__PURE__*/React.createElement(TextBase, null, title);

    default:
      return renderLink(item, onClose);
  }
};

var renderSubMenuItems = function renderSubMenuItems(group, onClose) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    level: 5,
    as: "p"
  }, group.title), /*#__PURE__*/React.createElement("ul", {
    className: cx('items')
  }, group.points && group.points.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.title,
      className: cx('item')
    }, renderSubMenuItem(item, onClose));
  })));
};

var renderB2CMenu = function renderB2CMenu(_ref2) {
  var navigation = _ref2.navigation,
      _onClick = _ref2.onClick,
      onClose = _ref2.onClose;
  return (navigation || []).map(function (_ref3, i) {
    var Component = _ref3.as,
        title = _ref3.title,
        href = _ref3.href,
        items = _ref3.items,
        blank = _ref3.blank,
        isBeta = _ref3.isBeta,
        rest = _objectWithoutProperties(_ref3, _excluded3);

    if (Component) {
      return /*#__PURE__*/React.createElement("div", {
        key: title,
        className: cx('group')
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('link 2222')
      }, /*#__PURE__*/React.createElement(Component, _extends({
        title: title,
        href: href,
        items: items,
        onClick: onClose
      }, rest))));
    }

    var type = href ? 'Link' : 'TextBase';
    var renderByType = {
      Link: renderLink({
        href: href,
        title: title,
        blank: blank,
        isBeta: isBeta
      }, function () {
        _onClick({
          href: href,
          title: title
        }, i);

        onClose();
      }),
      TextBase: /*#__PURE__*/React.createElement(Title, {
        level: 5,
        as: "p"
      }, title)
    };
    return /*#__PURE__*/React.createElement("div", {
      key: title,
      className: cx('group')
    }, renderByType[type], items && items.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: cx('items')
    }, items.map(function (item, index) {
      if (item.href) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.title,
          className: cx('item')
        }, renderLink(item, onClose));
      }

      if (item.title) {
        return /*#__PURE__*/React.createElement("button", {
          type: "button",
          key: item.title,
          className: cx('item'),
          onClick: function onClick() {
            return _onClick([i, index]);
          }
        }, /*#__PURE__*/React.createElement(TextBase, {
          as: "span"
        }, item.title), /*#__PURE__*/React.createElement(ChevronNormalRight, null));
      }

      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.title
      }, renderSubMenuItems(item, onClose));
    })));
  });
}; // eslint-disable-next-line react/prop-types


var renderB2BMenu = function renderB2BMenu(_ref4) {
  var navigation = _ref4.navigation,
      onClick = _ref4.onClick,
      onClose = _ref4.onClose;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('items')
  }, navigation.map(function (_ref5, i) {
    var Component = _ref5.as,
        item = _objectWithoutProperties(_ref5, _excluded4);

    if (Component) {
      return /*#__PURE__*/React.createElement("li", {
        key: item.title,
        className: cx('item', {
          item_active: item.active
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('link')
      }, /*#__PURE__*/React.createElement(Component, _extends({
        onClick: onClose
      }, item))));
    }

    return /*#__PURE__*/React.createElement("li", {
      key: item.title,
      className: cx('item', {
        item_active: item.active
      })
    }, renderLink(item, function () {
      onClick(item, i);
      onClose();
    }));
  }));
};

var renderMenu = function renderMenu(_ref6) {
  var active = _ref6.active,
      navigation = _ref6.navigation,
      onChange = _ref6.onChange,
      onClose = _ref6.onClose,
      setSubmenu = _ref6.setSubmenu,
      theme = _ref6.theme;

  switch (theme) {
    case themes.b2b:
      return renderB2BMenu({
        active: active,
        navigation: navigation,
        onClick: onChange,
        onClose: onClose
      });

    default:
      return renderB2CMenu({
        navigation: navigation,
        onClick: setSubmenu,
        onClose: onClose
      });
  }
};

var renderIcon = function renderIcon(theme, isMobile) {
  switch (theme) {
    case themes.b2b:
      return isMobile ? /*#__PURE__*/React.createElement(S7ProfiCircle, {
        height: 32,
        width: 32
      }) : /*#__PURE__*/React.createElement(S7Profi, {
        height: 32,
        width: 100
      });

    case themes.shop:
      return /*#__PURE__*/React.createElement("div", {
        className: cx('shop')
      }, /*#__PURE__*/React.createElement(S7Shop, {
        height: 32,
        width: 100
      }));

    default:
      return isMobile ? /*#__PURE__*/React.createElement(S7Circle, {
        height: 32,
        width: 32
      }) : /*#__PURE__*/React.createElement(S7, {
        height: 32,
        width: 100
      });
  }
};

export var MobileMenu = function MobileMenu(props) {
  var _navigation$submenuPa, _navigation$submenuPa2;

  var active = props.active,
      byPathname = props.byPathname,
      hint = props.hint,
      home = props.home,
      navigation = props.navigation,
      onChange = props.onChange,
      onClose = props.onClose,
      search = props.search,
      SearchProps = props.SearchProps,
      showSearch = props.showSearch,
      theme = props.theme,
      Region = props.Region,
      language = props.language;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSearch = _useState2[0],
      setIsSearch = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submenuPath = _useState4[0],
      setSubmenu = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      activeItem = _useState6[0],
      setActiveItem = _useState6[1];

  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;
  useEffect(function () {
    var newActive;

    if (isString(active)) {
      newActive = navigation.find(function (_ref7) {
        var href = _ref7.href;
        return href === active;
      });
    }

    if (isNumber(active)) {
      newActive = navigation[active];
    }

    if (isObject(active)) {
      newActive = navigation.find(function (item) {
        return active && (item === active || active.href && item.href === active.href || active.key && item.key === active.key) || byPathname && isObject(window) && window.location.pathname === item.href;
      });
    }

    setActiveItem(newActive);
  }, [active, byPathname, navigation]);
  var handleChange = useCallback(function (newActive, i) {
    if (newActive === activeItem) {
      return;
    }

    setActiveItem(newActive);

    if (onChange) {
      onChange(newActive, i);
    }
  }, [activeItem, onChange]);
  var handleClickSearch = useCallback(function () {
    setIsSearch(true);
  }, []);
  var selectedGroup = submenuPath ? navigation === null || navigation === void 0 ? void 0 : (_navigation$submenuPa = navigation[submenuPath[0]]) === null || _navigation$submenuPa === void 0 ? void 0 : (_navigation$submenuPa2 = _navigation$submenuPa.items) === null || _navigation$submenuPa2 === void 0 ? void 0 : _navigation$submenuPa2[submenuPath[1]] : null;
  var closeAndBackButton = /*#__PURE__*/React.createElement(React.Fragment, null, selectedGroup ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('back'),
    onClick: function onClick() {
      return setSubmenu(false);
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, null)) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClose,
    className: cx('close')
  }, /*#__PURE__*/React.createElement(CloseLinear, null)));
  var logo = renderIcon(theme, isMobile);
  return /*#__PURE__*/React.createElement("section", {
    className: cx('root', "theme_".concat(theme), {
      with_home: home,
      showSearch: showSearch,
      isSearch: isSearch
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('inner')
  }, !isSearch && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('head')
  }, closeAndBackButton, logo, /*#__PURE__*/React.createElement("div", {
    className: cx('actions')
  }, themes.b2b !== theme && /*#__PURE__*/React.createElement(Region, null), themes.b2b === theme && language)), !selectedGroup && showSearch && /*#__PURE__*/React.createElement("div", {
    className: cx('search')
  }, /*#__PURE__*/React.createElement(Search, {
    clearable: false,
    placeholder: search,
    onClick: handleClickSearch
  }))), isSearch && /*#__PURE__*/React.createElement("div", {
    className: cx('search_wrapper')
  }, /*#__PURE__*/React.createElement(HeaderSearch, _extends({
    theme: theme,
    mobile: true
  }, SearchProps, {
    onClose: function onClose() {
      return setIsSearch(false);
    }
  }))), /*#__PURE__*/React.createElement(Scrollbar, {
    className: cx('scroll')
  }, !isSearch && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('categories')
  }, selectedGroup ? renderSubMenuItems(selectedGroup, onClose) : renderMenu({
    active: activeItem,
    navigation: navigation,
    onChange: handleChange,
    setSubmenu: setSubmenu,
    theme: theme,
    onClose: onClose
  })), hint && /*#__PURE__*/React.createElement("div", {
    className: cx('hint')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('hint_title')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "m",
    weight: "semibold"
  }, hint.title)), /*#__PURE__*/React.createElement(Link, {
    href: hint.href,
    onClick: hint.onClick,
    view: theme,
    size: "m"
  }, hint.link), /*#__PURE__*/React.createElement(TextBase, {
    size: "m"
  }, hint.text)))), home && /*#__PURE__*/React.createElement("a", {
    className: cx('home'),
    href: home.href
  }, /*#__PURE__*/React.createElement(TextBase, null, home.title), /*#__PURE__*/React.createElement(ChevronNormalRight, null))), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    type: "button",
    className: cx('mobile_menu_close')
  }, "close mobile menu"));
};
var navigationPropType = process.env.NODE_ENV !== "production" ? shape({
  as: elementType,
  href: string,
  items: arrayOf(shape({
    itemKey: string,
    points: arrayOf(shape({
      href: string,
      key: string,
      title: string,
      type: oneOf(pointTypes),
      showIcon: bool
    })),
    title: string
  })),
  key: string,
  title: string,
  type: oneOf(pointTypes)
}) : {};
MobileMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  active: oneOfType([navigationPropType, number, string]),
  byPathname: bool,
  hint: shape({
    title: string,
    href: string,
    onClick: func
  }),
  home: shape({
    href: string,
    link: string,
    text: string,
    title: string
  }),
  navigation: arrayOf(navigationPropType),
  onChange: func,
  onClose: func,
  Region: elementType,
  language: node,
  search: string,
  SearchProps: shape(HeaderSearch.propTypes),
  showSearch: bool,
  theme: oneOf(Object.values(themes))
} : {};
MobileMenu.defaultProps = {
  active: null,
  byPathname: false,
  search: 'Поиск',
  theme: themes.b2c,
  navigation: []
};